import { defineStore } from 'pinia'
import { useStore } from '@/util/vuex'
import { computed } from 'vue'

export const useStudioStore = defineStore('studio', () => {
    const vuexStore = useStore()
    const studio = computed(() => vuexStore.getters['studio/getStudio'])
    return {
        studio,
    }
})
